import { Controller } from '@hotwired/stimulus';
import { hideModal, showModal } from '../utils/modal';

let completedTasksCount = 0;
const CELEBRATION_MODAL_INTERVALS = [1, 5, 10];
const CELEBRATION_MODAL_HEADER = {
  1: '1 Action Step Completed',
  5: '5 Action Steps Completed',
  10: '10 Action Steps Completed'
};
const CELEBRATION_MODAL_TEXT = {
  1: 'Woo-hoo! You completed your first action step.',
  5: 'You’ve completed five action steps! Keep up the momentum.',
  10: 'Wow, you’re on fire! You’ve completed 10 action steps so far.'
};

export default class CelebrationModalController extends Controller {
  static targets = ['header', 'text'];
  static values = {
    completedTasksInitialCount: Number
  };

  connect() {
    document.addEventListener(
      'taskCardComplete',
      this.onTaskCardComplete.bind(this)
    );
    completedTasksCount = this.completedTasksInitialCountValue;
  }

  onTaskCardComplete(event) {
    const { detail } = event;
    const isComplete = detail.completed;
    this.renderCelebrationModal(isComplete);
  }

  openModal() {
    const isModalActive = CELEBRATION_MODAL_INTERVALS.includes(
      completedTasksCount
    );

    if (!isModalActive) {
      return;
    }

    // Without a setTimeout this interferes with ajax on error
    // By pushing it to the end of the callstack we insure that the dom gets updated separately
    setTimeout(() => {
      this.renderCompletedCountLanguage(completedTasksCount);
      showModal('ActionStepsCelebrationModal', { disableFocus: true });
    }, 0);
  }

  dismissModal() {
    hideModal('ActionStepsCelebrationModal');
  }

  renderCompletedCountLanguage(completedCount) {
    this.headerTarget.innerHTML = CELEBRATION_MODAL_HEADER[completedCount];
    this.textTarget.innerHTML = CELEBRATION_MODAL_TEXT[completedCount];
  }

  incrementCompletedTasksCount() {
    completedTasksCount += 1;
  }

  decrementCompletedTasksCount() {
    completedTasksCount -= 1;
  }

  renderCelebrationModal(isComplete) {
    if (isComplete) {
      this.incrementCompletedTasksCount();
      this.openModal();

      return;
    }

    this.decrementCompletedTasksCount();
  }
}
